export const ROLES = {
  COSSUPORT_MANAGER: 'cosupport_manager',
  ADMIN: 'admin',
  MANAGER: 'manager',
  SUPPORT_TEAM_LEAD: 'support_team_lead',
  SUPPORT: 'support',
};

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLES_PRETTY: Record<string, string> = {
  cosupport_manager: 'CoSupport',
  admin: 'Admin',
  manager: 'Manager',
  support_team_lead: 'Team Lead',
  support: 'User',
};

export const SUBSCRIPTION_ACCESS_ROLES = [ROLES.COSSUPORT_MANAGER, ROLES.ADMIN];
export const OVERVIEW_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SUPPORT_TEAM_LEAD,
  ROLES.SUPPORT,
];
export const CONTROL_DESK_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SUPPORT_TEAM_LEAD,
  ROLES.SUPPORT,
];
export const INTEGRATION_ACCESS_ROLES = [ROLES.COSSUPORT_MANAGER, ROLES.ADMIN];
export const AGENT_ANALYTICS_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  // ROLES.ADMIN,
  // ROLES.MANAGER,
  // ROLES.SUPPORT_TEAM_LEAD,
];
export const CUSTOMER_ANALYTICS_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SUPPORT_TEAM_LEAD,
  ROLES.SUPPORT,
];
export const CONVERSATIONS_ACCESS_ROLES = [ROLES.COSSUPORT_MANAGER, ROLES.ADMIN, ROLES.MANAGER];
export const PLAYGROUND_ACCESS_ROLES = [ROLES.COSSUPORT_MANAGER, ROLES.ADMIN, ROLES.MANAGER];
export const CONFIGURATION_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SUPPORT_TEAM_LEAD,
  ROLES.SUPPORT,
];
export const ACCOUNT_ACCESS_ROLES = [ROLES.COSSUPORT_MANAGER, ROLES.ADMIN, ROLES.MANAGER];
export const KNOWLEDGE_BASE_ACCESS_ROLES = [
  ROLES.COSSUPORT_MANAGER,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SUPPORT_TEAM_LEAD,
  ROLES.SUPPORT,
];
